<script lang="ts">
	//Hooks
	import { createEventDispatcher, onMount, getContext } from 'svelte';
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Button } from '@Shelly/shelly-design-system';
	//Types
	import type { MapContext } from '../../../types/requests/services/weather';

	const { getMap }: MapContext = getContext('map'),
		map = getMap(),
		dispatcher = createEventDispatcher();

	let zoom = 12;

	export let isLoading = false;

	onMount(() => {
		onZoom();
		map.on('zoom', onZoom);
		return () => map.off('zoom', onZoom);
	});
	const onZoom = () => {
		zoom = map.getZoom();
	};
	const searchInThisArea = () => {
		const center = map.getCenter();
		dispatcher('change', { lat: center.lat, lon: center.lng });
	};
</script>

<div class="search-in-this-area">
	<Button
		size="m"
		disabled={zoom >= 12 || zoom <= 9 || isLoading}
		icon="fas fa-search"
		loading={isLoading}
		on:click={searchInThisArea}
	>
		{$format('button_location_search_in_this_area', {
			default: 'Search in this area',
		})}
	</Button>
</div>

<style>
	.search-in-this-area {
		display: table;
		position: absolute;
		top: 60px;
		left: 0;
		right: 0;
		z-index: 3;
		margin: 0 auto;
	}

	@media (max-width: 640px) {
		.search-in-this-area {
			left: 15px;
			margin: 0;
		}
	}
</style>
